import { takeLatest, call } from "redux-saga/effects";
import {
  GET_ALL_VIDEOS,
  CREATE_VIDEO,
  UPDATE_VIDEO,
  DELETE_VIDEO,
} from "../types";
import {
  GetAllVideosApi,
  CreateVideoApi,
  UpdateVideoApi,
  DeleteVideoApi,
} from "../api/videos-api";

/**
 * Every worker hands `res.data` — the whole body — to onSuccess, matching the
 * rest of this app's sagas. Failures arrive as HTTP 200 with `status: false`, so
 * the body decides, not the HTTP code alone.
 */
export function* getAllVideosWorker(action: any): any {
  try {
    const res: any = yield call(GetAllVideosApi, action.keyword);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createVideoWorker(action: any): any {
  try {
    const res: any = yield call(CreateVideoApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateVideoWorker(action: any): any {
  try {
    const res: any = yield call(UpdateVideoApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteVideoWorker(action: any): any {
  try {
    const res: any = yield call(DeleteVideoApi, action.videoId);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllVideosWatcher() {
  yield takeLatest(GET_ALL_VIDEOS, getAllVideosWorker);
}
export function* createVideoWatcher() {
  yield takeLatest(CREATE_VIDEO, createVideoWorker);
}
export function* updateVideoWatcher() {
  yield takeLatest(UPDATE_VIDEO, updateVideoWorker);
}
export function* deleteVideoWatcher() {
  yield takeLatest(DELETE_VIDEO, deleteVideoWorker);
}
